import { ButtonProps } from 'antd/lib/button';

import { UiButton } from '../ui-button';

type Props = {
  onClick: () => void;
} & ButtonProps;

export function UiDeleteFormButton(props: Props) {
  return (
    <UiButton
      {...props}
      htmlType="button"
      type="primary"
      danger
      onClick={props.onClick}
    >
      Удалить
    </UiButton>
  );
}
